import { Stack } from '@atlaskit/primitives';

import type { RepositorySettingValue } from '../../../../../../typings/globals';

import { CodeReviewerAcceptanceCriteriaToggle } from './toggle/code-reviewer-acceptance-criteria-toggle';
import { CodeReviewerRepositorySettingToggle } from './toggle/code-reviewer-repository-setting-toggle';
import { UsingCodeReviewer } from './using-code-reviewer';

type GithubRepositorySettingsProps = {
	selectedRepo: GH.Repository;
	updateRepoSettings: (update: RepositorySettingValue) => void;
};

export const GithubRepositorySettings = ({
	selectedRepo,
	updateRepoSettings,
}: GithubRepositorySettingsProps) => {
	return (
		<Stack space="space.250">
			<CodeReviewerRepositorySettingToggle
				repository={selectedRepo}
				updateRepoSettings={updateRepoSettings}
			/>
			<CodeReviewerAcceptanceCriteriaToggle
				repository={selectedRepo}
				updateRepoSettings={updateRepoSettings}
			/>
			<UsingCodeReviewer />
		</Stack>
	);
};
